export function place_delete_item(tableData, delete_item) {
    tableData.forEach(item => {
        if (item.id == delete_item.id) {
            item.check = false;
            item.type = '';
            item.cycle = 1
        }
    });
}